module.exports = __webpack_public_path__ + "images/maskable_icon-384.f77f78092cf797a38d40986dfc4f6412.png";